import { Outlet } from "react-router";

import SettingsSpeciesCreateRoute from "./routes/SettingsSpeciesCreateRoute";
import SettingsSpeciesEditRoute from "./routes/SettingsSpeciesEditRoute";
import SettingsSpeciesListRoute from "./routes/SettingsSpeciesListRoute";

export const speciesRoutes = [
    {
        path: "species",
        handle: { breadcrumb: "species:settingsSpeciesListRoute.title" },
        element: <Outlet />,
        children: [
            { index: true, element: <SettingsSpeciesListRoute /> },
            {
                path: "new",
                handle: { breadcrumb: "species:settingsSpeciesCreateRoute.title" },
                element: <SettingsSpeciesCreateRoute />,
            },
            {
                path: ":speciesId",
                handle: { breadcrumb: "species:settingsSpeciesEditRoute.title" },
                element: <SettingsSpeciesEditRoute />,
            },
        ],
    },
];
